const STORAGE_KEY_PETS = 'mpp_pets_v1';
const STORAGE_KEY_CART = 'mpp_cart_v1';

export const loadPets = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PETS);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    const cleaned = parsed
      .filter((p) => p && typeof p === 'object')
      .map((p) => ({
        id: typeof p.id === 'string' ? p.id : `pup-${Date.now()}`,
        title: typeof p.title === 'string' ? p.title : 'Pup',
        images: Array.isArray(p.images) ? p.images.filter((x) => typeof x === 'string') : [],
        sex: typeof p.sex === 'string' ? p.sex : '',
        breed: typeof p.breed === 'string' ? p.breed : '',
        status: typeof p.status === 'string' ? p.status : 'Available',
        price: typeof p.price === 'number' ? p.price : null,
        age: typeof p.age === 'string' ? p.age : '',
        weight: typeof p.weight === 'string' ? p.weight : '',
        size: typeof p.size === 'string' ? p.size : '',
        description: typeof p.description === 'string' ? p.description : ''
      }))
      .filter((p) => p.images.length > 0);

    const looksLikeOldDefaults =
      cleaned.length > 0 && cleaned.every((p) => p.id.startsWith('pup-') && /^Pup #/i.test(p.title));
    if (looksLikeOldDefaults) return null;

    return cleaned.length ? cleaned : null;
  } catch {
    return null;
  }
};

export const savePets = (pets) => {
  localStorage.setItem(STORAGE_KEY_PETS, JSON.stringify(pets));
};

export const loadCart = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_CART);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x) => typeof x === 'string');
  } catch {
    return [];
  }
};

export const saveCart = (petIds) => {
  localStorage.setItem(STORAGE_KEY_CART, JSON.stringify(petIds));
};
